import {createEvent} from "./createEvent";

export const navigationEvents = {
    pageChanged: createEvent(),
};
